// MUI Components
import { Box } from '@mui/material';

// Contexts
import { useTheme } from '../../contexts/ThemeContext';

export default function ProductImage({ src, alt }) {
  const { theme } = useTheme();

  return (
    <Box
      flex={1}
      display="flex"
      justifyContent="center"
      alignItems="flex-start"
      sx={{ maxWidth: { xs: '100%', sm: 200 } }}
    >
      <Box
        component="img"
        src={src}
        alt={alt}
        loading="eager"
        onError={({ currentTarget }) => {
          currentTarget.onerror = null;
          currentTarget.src = "https://i5.walmartimages.com/seo/Unavailable.jpeg";
        }}
        sx={{
          width: '100%',
          maxWidth: 180,
          maxHeight: 180,
          objectFit: 'contain',
          borderRadius: 2,
          boxShadow: 2,
          bgcolor: theme.background.tertiary,
          padding: 1,
          border: `1px solid ${theme.border.light}`,
          transition: 'opacity 0.2s ease-in-out',
          animation: 'fadeIn 0.3s ease-out',
          '@keyframes fadeIn': {
            from: { opacity: 0.6 },
            to: { opacity: 1 },
          }
        }}
      />
    </Box>
  );
}
